module.exports = __webpack_public_path__ + "static/media/mediaListIconActive.85c95eea.svg";